var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"gl-h-10 gl-w-10",attrs:{"src":_vm.$options.tanukiAiSvgUrl,"alt":_vm.s__('DuoAgenticChat|GitLab Duo AI assistant')}})
}
var staticRenderFns = []

export { render, staticRenderFns }